import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export type RouteChangeCallback = (pathname: string) => void;

export const useRouteChangeEffect = (
  callback: RouteChangeCallback
): void => {
  const { pathname } = useLocation();
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    callbackRef.current(pathname);
  }, [pathname]);
};

export default useRouteChangeEffect;